/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/Companies.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Company Reducers 
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    COMPANY_LIST_CONTAINER_LOADED,
    COMPANY_LIST_CONTAINER_UNLOADED,
    COMPANY_LIST_TABLE_LOADED,
    COMPANY_LIST_TABLE_UNLOADED,
    COMPANY_LIST_CHANGE_STATUS,
    COMPANY_SELECT_ROW,
    COMPANY_ADD,
    COMPANY_EDIT,
    COMPANY_DELETE,
    COMPANY_DELETE_DISABLE,
    COMPANY_OPEN_WARNING,
    COMPANY_CLOSE_WARNING,
    COMPANY_EDIT_CONTAINER_LOADED,
    COMPANY_EDIT_CONTAINER_UNLOADED,
    COMPANY_EDIT_FORM_LOADED,
    COMPANY_EDIT_FORM_UNLOADED,
    COMPANY_EDIT_DATA_LOAD,
    COMPANY_EDIT_CONTAINER_SUBMIT,
    COMPANY_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeCompanies';

const defaultState = {
    refreshList: false,
    companies: [],
    companystatuses: [],
    danger: false,
    companyid: 0,
    name: '',
    description: '',
    companystatusid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case COMPANY_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                companies: action.payload[0] ? action.payload[0].companies : [],
                companystatuses: action.payload[1] ? action.payload[1].companystatuses : []
            }
        case COMPANY_LIST_CHANGE_STATUS:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                companies: action.payload ? action.payload.companies : []
            }
        case COMPANY_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case COMPANY_SELECT_ROW:
            return {
                ...state,
                companyid: action.id
            }
        case COMPANY_ADD:
            return {
                ...state
            }
        case COMPANY_EDIT:
            return {
                ...state,
                companyid: action.id
            }
        case COMPANY_DELETE:
            return {
                ...state,
                companyid: null
            }
        case COMPANY_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case COMPANY_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case COMPANY_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case COMPANY_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                companystatuses: action.payload[1] ? action.payload[1].companystatuses : [],
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                companystatusid: action.payload[0] ? action.payload[0].companystatusid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case COMPANY_EDIT_DATA_LOAD:
            return {
                ...state,
                companyid: action.payload ? action.payload.companyid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                companystatusid: action.payload ? action.payload.companystatusid : 0,
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case COMPANY_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case COMPANY_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case COMPANY_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case COMPANY_LIST_CONTAINER_UNLOADED:
        case COMPANY_LIST_TABLE_UNLOADED:
        case COMPANY_EDIT_CONTAINER_UNLOADED:
        case COMPANY_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Companies.js